import type { Metadata } from "next"
import { siteConfig } from "~/config/site"

export const metadataConfig: Metadata = {
  keywords: siteConfig.keywords,
  robots: {
    index: true,
    follow: true,
    googleBot: {
      index: true,
      follow: true,
      'max-video-preview': -1,
      'max-image-preview': 'large',
      'max-snippet': -1,
    },
  },
  openGraph: {
    url: "/",
    siteName: siteConfig.name,
    title: `${siteConfig.name} – ${siteConfig.tagline}`,
    description: siteConfig.description,
    locale: "en_US",
    type: "website",
    images: {
      url: `${siteConfig.url}/og.webp`,
      width: 1200,
      height: 630,
      alt: `${siteConfig.name} - ${siteConfig.tagline}`,
      type: "image/png"
    },
  },
  twitter: {
    site: "@iotsecpulse",
    creator: "@iotsecpulse",
    card: "summary_large_image",
    title: `${siteConfig.name} – ${siteConfig.tagline}`,
    description: siteConfig.description,
    images: {
      url: `${siteConfig.url}/og.webp`,
      width: 1200,
      height: 630,
      alt: `${siteConfig.name} - ${siteConfig.tagline}`,
      type: "image/png"
    }
  },
  alternates: {
    canonical: "/",
  },
  category: "Network Security",
}
